import { PostProperties } from "../types";
import image from "../img/lostGemSurgeon.jpg";

const post: PostProperties = {
  id: 42,
  title: "Surgeon - Big Bang Sessions, Spybar, Chicago (07.10.2005)",
  content: `Anthony Child is undoubtedly one of the most important electronic music artists. Under the Surgeon pseudonym, Child has released many cherished classics that continue to rock the dancefloors around the world. He continues to be an inspiration for many young artists and fans of electronic music.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/surgeon-big-bang-sessions-spy-bar-chicago-07102005",
  category: "Lost Gem",
  translationsBg: {
    content: `Антъни Чайлд несъмнено е един от най-важните изпълнители на електронна музика. Под псевдонима Surgeon, Чайлд е издал много ценени класики, които продължават да разтърсват дансингите по целия свят. Той продължава да бъде вдъхновение за много млади изпълнители и фенове на електронната музика.`,
  },
};

export default post;
